export const GF_LOG = new Uint8Array(256);
